import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
const chapters = [{
  pages: 'Página 1-3',
  title: 'El mapa mental del freelancer en dólares'
}, {
  pages: 'Página 4-6',
  title: 'Las 5 habilidades más demandadas que ya tienes'
}, {
  pages: 'Página 7-9',
  title: 'Cómo crear tu perfil que atrae clientes de EE.UU.'
}, {
  pages: 'Página 10-12',
  title: 'Configurar Wise/Airtm paso a paso (con capturas)'
}, {
  pages: 'Página 13-15',
  title: 'Las plantillas exactas para contactar clientes'
}, {
  pages: 'Página 16-18',
  title: 'Cómo cobrar sin perder dinero en comisiones'
}, {
  pages: 'Página 19-20',
  title: 'Plan de acción de 14 días para tu primer pago'
}];
export function ManualContents() {
  return <section className="py-24 px-4 bg-[#0A0A0A]" data-id="element-28">
      <div className="max-w-5xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white" data-id="element-31">
            ¿Qué Hay <span className="text-[#C9A84C]" data-id="element-32">Dentro del Manual?</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-33">
          {chapters.map((chapter, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.4
        }} className="flex items-start gap-4 p-6 bg-[#0f0f0f] border border-neutral-800 rounded-xl hover:border-[#C9A84C]/40 transition-colors group" data-id="element-34">
              <div className="flex-shrink-0 p-3 bg-[#0A0A0A] rounded-lg border border-neutral-800 group-hover:border-[#C9A84C]/50 transition-colors" data-id="element-35">
                <BookOpenIcon className="w-6 h-6 text-[#C9A84C]" data-id="element-36" />
              </div>
              <div data-id="element-37">
                <span className="text-sm font-bold text-[#C9A84C] tracking-wider uppercase mb-1 block" data-id="element-38">
                  {chapter.pages}
                </span>
                <h3 className="text-lg font-semibold text-[#D1D5DB]" data-id="element-39">
                  {chapter.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}